import React from "react";

import { Divider } from "@material-ui/core";

import Anon from "@material-ui/icons/Lock";
import Compare from "@material-ui/icons/CompareArrows";
import Aggregate from "@material-ui/icons/CallMerge";
import OfflineBolt from "@material-ui/icons/FlashOnOutlined";
import AttachMoney from "@material-ui/icons/AttachMoneyOutlined";
import Reporting from "@material-ui/icons/ListAltOutlined";
import UserManaged from "@material-ui/icons/Person";

import HireFire from "@material-ui/icons/ThumbsUpDownOutlined";
import MgmtFees from "@material-ui/icons/MoneyOffOutlined";
import RiskReturn from "@material-ui/icons/TrendingUpOutlined";
import Flag from "@material-ui/icons/FlagOutlined";
import Info from "@material-ui/icons/Warning";
import Swap from "@material-ui/icons/SwapVert";

import Fab from "@material-ui/core/Fab";
import Heading from "./components/Heading";
import Footer from "./components/Footer";

import "./home.css";
import styled from "styled-components";
import ContentSection from "./components/ContentSection";
import { hashHistory } from "browserHistory";

// import { getUserRegion } from "helpers/userStorage";
import WorldFlags from "react-world-flags";
import Button from "@material-ui/core/Button";
import Timer from "@material-ui/icons/Timer";

const Page = styled.div`
  height: calc(100vh - 85px);
`;

const Content = styled.div`
  height: 100%;
  width: 100%;

  @media screen {
    overflow: auto;
  }
`;

const DataEntry = (props) => {
  const whyRppaRef = React.useRef();
  const featuresRef = React.useRef();
  const contentRef = React.useRef();
  const pricingRef = React.useRef();

  function getListItem(Icon, header, text) {
    return (
      <div style={{ display: "flex", margin: 10 }}>
        <div style={{ marginRight: 10, marginTop: 3 }}>
          <Icon style={{ fontSize: 40 }} />
        </div>
        <div>
          <div style={{ fontSize: 24 }}>{header}</div>
          <div>{text}</div>
        </div>
      </div>
    );
  }

  function getContentSection2(
    label,
    items1,
    x = false,
    items2,
    textDescription,
    ref
  ) {
    return (
      <ContentSection minHeight={0}>
        <div ref={ref}>
          <div style={{ marginTop: panelMargin, marginBottom: panelMargin }}>
            <h2 style={{ textAlign: "center" }}>{label}</h2>
            {/* <div>Some text describing why and what this product does</div> */}
            <div className="contentList">
              <div style={{ textAlign: "left" }} className="contentListItem">
                {items1}
              </div>
              <div className="contentListItem" style={{ textAlign: "left" }}>
                {items2}
              </div>
            </div>
            {textDescription && (
              <div style={{ margin: 20, textAlign: "center" }}>
                {textDescription}
              </div>
            )}
          </div>
        </div>
      </ContentSection>
    );
  }

  const panelMargin = 50;

  var headingItems = [
    {
      title: "Why RoboPPA™?",
      style: { marginTop: 5 },
      onClick: () => {
        contentRef.current.scroll({
          top: whyRppaRef.current.offsetTop - 85,
          left: 0,
          behavior: "smooth",
        });
      },
    },
    {
      title: "Portfolio Analysis",
      style: { marginTop: 5 },
      onClick: () => {
        contentRef.current.scroll({
          top: featuresRef.current.offsetTop - 85,
          left: 0,
          behavior: "smooth",
        });
      },
    },
    {
      title: "Pricing",
      style: { marginTop: 5 },
      onClick: () => {
        contentRef.current.scroll({
          top: pricingRef.current.offsetTop - 85,
          left: 0,
          behavior: "smooth",
        });
      },
    },
  ];

  return (
    <div>
      <Heading {...props} buttons={headingItems} refreshOnLogin={false} />
      <Page>
        <Content ref={contentRef}>
          <div style={{}}>
            <div style={{ fontFamily: "Poppins,Roboto" }}>
              <div style={{ backgroundColor: "#212224", color: "white" }}>
                {/* Top Content */}
                <ContentSection minHeight={0}>
                  <div>
                    <div style={{ display: "flex", marginTop: 0 }}>
                      <div
                        style={{
                          marginLeft: 40,
                          marginRight: -80,
                          height: 300,
                          width: 600,
                        }}
                      >
                        <img
                          src="/images/elkgreysm.png"
                          style={{
                            width: 400,
                            position: "relative",
                            zIndex: 1,
                          }}
                          alt=""
                        />
                      </div>
                      <div
                        style={{ textAlign: "right", marginTop: 50, zIndex: 2 }}
                      >
                        <h1>Robo Portfolio Performance Analyzer™</h1>
                        <div style={{ fontSize: 18, marginTop: 5 }}>
                          anonymous and independent risk and return analysis
                          {/* <br/>for portfolio owners and managers */}
                        </div>
                        <div style={{ marginTop: 20 }}>
                          <Fab
                            variant="extended"
                            color="primary"
                            style={{ fontSize: 18, textTransform: "initial" }}
                            onClick={() => {
                              hashHistory.push("/DataEntry");
                            }}
                          >
                            Get Started
                          </Fab>
                        </div>
                      </div>
                    </div>
                  </div>
                </ContentSection>
                <div
                  style={{
                    width: "100%",
                    backgroundColor: "#3e51b4",
                    height: 40,
                  }}
                ></div>
              </div>

              <ContentSection minHeight={0} style={{ marginBottom: 20 }}>
                {/* <div style={{ fontSize: 34, textAlign: 'center' }}>Design and Methodology</div> */}
                <div className="contentList" style={{ marginTop: 0 }}>
                  {/* <div style={{ width: 300 }}><Methodology style={{ fontSize: 80, marginTop: 15 }} /></div> */}
                  <div style={{ marginLeft: 20, textAlign: "center" }}>
                    <p>
                      RoboPPA™ is a sophisticated portfolio performance
                      evaluation tool that respects portfolio privacy. Our
                      objective is to help investors and portfolio managers
                      diagnose problems and improve portfolio performance. It is
                      based on financial and statistical principles that conform
                      to investor’s preferences for more portfolio return and
                      less portfolio risk. Analysis is based on well-known and
                      accepted financial research.
                    </p>
                  </div>
                </div>
              </ContentSection>
              <Divider />

              <div ref={pricingRef}>
                <ContentSection minHeight={0}>
                  <div ref={null}>
                    <div
                      style={{
                        marginTop: panelMargin,
                        marginBottom: panelMargin,
                      }}
                    >
                      <h2 style={{ textAlign: "center" }}>Pricing</h2>
                      <div style={{ marginLeft: 20, textAlign: "center" }}>
                        {/* <p
                          style={{
                            fontSize: 16,
                            textDecoration: "line-through",
                          }}
                        >
                          $25CAD or $20USD per report.
                        </p>
                        <p style={{ fontSize: 22, fontWeight: "bold" }}>
                          Free!
                        </p> */}
                        <p>
                          Currently, all Robo Portfolio Analyses is provided at
                          no cost!
                        </p>
                        {/* <p>
                          This is a limited time offer, so act now before it is
                          too late.
                        </p> */}
                      </div>
                    </div>
                  </div>
                </ContentSection>
              </div>
              <Divider />

              {getContentSection2(
                "Why RoboPPA™?",
                <div>
                  {getListItem(
                    UserManaged,
                    "Owner Managed",
                    "Portfolio analysis is applicable to either owner managed or externally managed portfolios. If externally managed, fees are typically applicable; if owner managed, management fees are typically zero."
                  )}
                  {getListItem(
                    Anon,
                    "Anonymity!",
                    "No need to divulge the portfolio owner’s or manager’s names, the portfolio value, the assets’ names, or the historical asset trades."
                  )}
                  {getListItem(
                    Compare,
                    "Comparisons",
                    "Validate performance numbers and conclusions from your portfolio’s reports.  RoboPPA compares your portfolio’s performance with an appropriate and low fee market traded benchmark."
                  )}
                  {getListItem(
                    Aggregate,
                    "Aggregation",
                    "You may combine any number of your portfolios for an analysis of aggregate portfolio performance."
                  )}
                </div>,
                false,
                <div>
                  {getListItem(
                    RiskReturn,
                    "Risk and Return",
                    "Rather than a return only analysis, both your portfolio’s risk and return are evaluated."
                  )}
                  {/* {getListItem(OfflineBolt, '', '')}
                                {getListItem(OfflineBolt, '', '')} */}
                  {getListItem(
                    OfflineBolt,
                    "Instant Analysis",
                    "Your portfolio analysis will be instantly available once you enter the required data."
                  )}
                  {getListItem(
                    Reporting,
                    "Detailed Reporting",
                    "Your report will contain charts and analysis, as well as bottom line conclusions, to assist your portfolio management decisions."
                  )}
                  {getListItem(
                    MgmtFees,
                    "Low Cost",
                    "No subscription required; pay only for each portfolio and historical time period analyzed."
                  )}
                  {getListItem(
                    AttachMoney,
                    "Contributions and Withdrawals",
                    'Return calculations properly reflect your portfolio contributions and withdrawals rather than a "one fits all return calculation".'
                  )}
                </div>,
                <div></div>,
                whyRppaRef,
                this
              )}

              <Divider />
              <ContentSection minHeight={0} style={{ marginBottom: 20 }}>
                <div className="contentList" style={{ marginTop: 0 }}>
                  <div style={{ textAlign: "center", width: 100 }}>
                    {/* <Privacy style={{ fontSize: 40, marginTop: 15 }} /> */}
                  </div>
                  <div style={{ marginLeft: 20, textAlign: "center" }}>
                    <p>
                      We do not need to know the true value of your portfolio,
                      so we don't ask for it. We facilitate your privacy by
                      using a Portfolio Privacy Factor (PPF) that hides your
                      portfolio’s true inputs. This factor is calculated by you
                      and is not available to the software or anyone else. In
                      addition, you have the option to permanently delete
                      reports saved to our servers.
                    </p>
                  </div>
                  <div style={{ textAlign: "center", width: 100 }}>
                    {/* <Privacy style={{ fontSize: 40, marginTop: 15 }} /> */}
                  </div>
                </div>
              </ContentSection>
              <Divider />
              {getContentSection2(
                "Portfolio Analysis",
                <div>
                  {getListItem(
                    RiskReturn,
                    "Portfolio Return",
                    "Two types of return calculated before and after management fees, if any, and compared with your benchmark’s returns."
                  )}
                  {getListItem(
                    AttachMoney,
                    "Portfolio Fees",
                    "The loss in end of period portfolio value, due to management fees, if any, is reported.  Your benchmark’s fees are estimated and the manager’s actual value added to the benchmark is shown."
                  )}
                  {getListItem(
                    Swap,
                    "Portfolio Return versus Risk",
                    "Are the risks worth the return? Portfolio and benchmark volatility and downside risks are compared and evaluated."
                  )}
                  {getListItem(
                    Info,
                    "Other Portfolio Characteristics",
                    "Your portfolio’s return sensitivities to some economic and market factors provide information that may cause you to alter your portfolio’s asset class allocations."
                  )}
                </div>,
                true,
                <div>
                  {getListItem(
                    Timer,
                    "Market Timing",
                    "The ability of the portfolio and benchmark to time the stock market is determined and evaluated for a random occurrence."
                  )}
                  {getListItem(
                    HireFire,
                    "The Bottom Line",
                    "Is your portfolio superior to your benchmark? Our estimate of the management value-added after risk is provided to aid in answering the question."
                  )}
                  {getListItem(
                    Flag,
                    "Multiple Currencies",
                    "Obtain performance analysis of US or CDN dollar denominated portfolios, regardless of the portfolio’s resident country."
                  )}
                </div>,
                <div></div>,
                featuresRef,
                this
              )}
              <Divider />

              {/* <div ref={pricingRef}>
                <ContentSection minHeight={0}>
                  <div ref={null}>
                    <div
                      style={{
                        marginTop: panelMargin,
                        marginBottom: panelMargin,
                      }}
                    >
                      <div style={{ fontSize: 34, textAlign: "center" }}>
                        Pricing
                      </div>
                      <div style={{ marginLeft: 20, textAlign: "center" }}>
                        <p style={{ fontSize: 18 }}>
                          RoboPPA reports can be generated for <b>$25CAD</b> or{" "}
                          <b>$20USD</b> per report.
                        </p>
                        <p>
                          A limited report preview is available, at no cost.
                        </p>
                        <p>
                          Quantity discounts are available; please contact{" "}
                          <a href="mailto:support@roboppa.com">
                            support@RoboPPA.com
                          </a>{" "}
                          for more information.
                        </p>
                        <p>Inquiries are welcome.</p>
                      </div>
                    </div>
                  </div>
                </ContentSection>
              </div>
              <Divider /> */}

              <div>
                <ContentSection minHeight={0}>
                  <div ref={null}>
                    <div
                      style={{
                        marginTop: panelMargin,
                        marginBottom: panelMargin,
                      }}
                    >
                      <h2 style={{ textAlign: "center" }}>Sample Reports</h2>
                      <div style={{ marginLeft: 20, textAlign: "center" }}>
                        <div style={{ display: "inline-flex" }}>
                          <div style={{ margin: "10px 40px" }}>
                            <div>
                              <WorldFlags code={"CAN"} height={100} />
                            </div>
                            <div>
                              <Button
                                variant={"text"}
                                color={"primary"}
                                onClick={() => {
                                  window.open(
                                    "/#/Portfolio/6784739c-c095-4b5b-915d-7e92400d37a4"
                                  );
                                }}
                              >
                                View Sample Report
                              </Button>
                            </div>
                          </div>
                          <div style={{ margin: "10px 40px" }}>
                            <div>
                              <WorldFlags code={"USA"} height={100} />
                            </div>
                            <div>
                              <Button
                                variant={"text"}
                                color={"primary"}
                                onClick={() => {
                                  window.open(
                                    "/#/Portfolio/391635af-b36d-43e4-95d9-94195046496c"
                                  );
                                }}
                              >
                                View Sample Report
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ContentSection>
              </div>
              <Divider />
            </div>
            <div
              style={{
                backgroundColor: "#212224",
                color: "white",
                padding: 40,
                textAlign: "center",
              }}
            >
              {/* <div style={{ fontSize: 30, marginBottom: 20 }}>
                            Get started now
                    </div> */}
              <Fab
                variant="extended"
                color="primary"
                style={{ fontSize: 24, textTransform: "initial" }}
                onClick={() => {
                  hashHistory.push("/DataEntry");
                }}
              >
                Get Started Now
              </Fab>
            </div>
          </div>
          <Footer />
        </Content>
      </Page>
    </div>
  );
};

export default DataEntry; // connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(tmp));



// WEBPACK FOOTER //
// ./src/home/HomePage.js